// extracted by mini-css-extract-plugin
export default {"backIcon":"AdminMobileProductRegister_backIcon__zqx5h","regiBtn":"AdminMobileProductRegister_regiBtn__PW5l7"};